import firebase from "../../../config/firebase";

// Actions
import {
  setCurrentCompany,
  removeCurrentCompany
} from "../../actions/companyActions";

const db = firebase.firestore(); // Initialize Database

// Getting All Companies
export const getAllCompanies = query => {
  console.log("getAllJobs Caleed==", query);
  return db
    .collection("companies")
    .orderBy("id", "desc")
    .limit(query.limit)
    .get();
};

export const getMoreCompanies = query => {
  console.log("getMoreAllJobs Caleed==", query);
  return db
    .collection("companies")
    .orderBy("id", "desc")
    .limit(query.limit)
    .startAfter(query.startAfter)
    .get();
};

// // Get Companies by email
export const getCompanyByEmail = query => {
  console.log("getCompanyByEmail Caleed==", query);
  return db
    .collection("companies")
    .orderBy("id", "desc")
    .where("email", "==", query.email)
    .limit(query.limit)
    .get();
};

// Getting Current Company
export const getCurrentCompany = email => dispatch => {
  console.log({ email });
  try {
    if (email) {
      console.log(email);
      db.collection("companies")
        .where("email", "==", `${email}`)
        .get()
        .then(snapShot => {
          if (!snapShot.empty) {
            let companyArray = [];
            snapShot.forEach(async docs => {
              console.log(docs);
              companyArray.push({ ...docs.data(), id: docs.id });
            });
            console.log(companyArray);
            dispatch(setCurrentCompany(companyArray[0]));
          } else {
            dispatch(removeCurrentCompany());
          }
        })
        .catch(error => console.log(error));
    }
  } catch (error) {
    console.log(error);
  }
};

// Getting company by email
export const getThisCompany = email => {
  console.log({ email });
  if (email) {
    console.log(email);
    db.collection("companies")
      .where("email", "==", `${email}`)
      .get()
      .then(snapShot => {
        if (!snapShot.empty) {
          let companyArray = [];
          snapShot.forEach(async docs => {
            console.log(docs);
            companyArray.push({ ...docs.data(), id: docs.id });
          });
          console.log(companyArray);
          // dispatch(setCurrentCompany(companyArray[0]));
        } else {
          // dispatch(removeCurrentCompany());
        }
      })
      .catch(error => console.log(error));
  }
};

//  Get single Job With Id
export const getCompanyWithId = id => {
  console.log("getCompanyWithId Caleed==", id);
  return db
    .collection("companies")
    .doc(id)
    .get();
};
